import DocumentMeta from "react-document-meta";

const Nosotros = () => {
    return (
        <DocumentMeta
            title="Nosotros"
            description="Nos enfocamos en la fabricación y comercialización de equipos de dosificación y medición confiables, utilizando insumos de alta calidad, la última tecnología disponible y nuestra experiencia de más de 35 años en el rubro en áreas tales como tratamiento de aguas y efluentes, industrias químicas, petroquímicas, alimenticias y farmacéuticas."
            canonical="https://ares.com.ar/nosotros"
            meta={{
                charset: 'utf-8',
                name: {
                    keywords: 'nosotros, ares, dosificación, medición, insumos, calidad, tecnología, experiencia, tratamiento, aguas, efluentes, industrias, químicas, petroquímicas, alimenticias, farmacéuticas'
                }
            }
            }
        >
            <div className="page-title-area ptb-100">
                <div className="container">
                    <div className="page-title-content">
                        <h1>Nosotros</h1>
                    </div>
                </div>
                <div className="bg-image">
                    <img src={process.env.PUBLIC_URL + "/assets/img/banner/title.jpg"} alt="" />
                </div>
            </div>
            <div className="about-single-area ptb-100">
                <section id="about" className="about-section about-section-single">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="image-content mb-30" style={{ background: 'url(' + process.env.PUBLIC_URL + "/assets/img/nosotros/silo.jpg" + ')' }}>
                                    <img src={process.env.PUBLIC_URL + "/assets/img/nosotros/about-single-1.jpg"} alt="" className="img1" />
                                    <img src={process.env.PUBLIC_URL + "/assets/img/nosotros/dosificar2.jpg"} alt="" className="img2" />
                                    <div className="count">
                                        <h2>40</h2>
                                        <span>Años de trayectoria</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="about-content">
                                    <h2>
                                        Innovación y <span>servicio</span>
                                    </h2>
                                    <p>
                                        Nos enfocamos en el desarrollo y la fabricación de equipos de dosificación y medición utilizando insumos de alta calidad, la última tecnología disponible y nuestra experiencia de más de 40 años en el rubro en áreas tales como tratamiento de aguas y efluentes, industrias químicas, petroquímicas, alimenticias y farmacéuticas. Nuestra empresa provee equipos simples para dosificación convencional y es además pionera en la fabricación de bombas compactas que dosifican en forma inteligente, registrando mediciones y eventos (datalogging). ARES sigue invirtiendo en innovaciones tecnológicas sin descuidar el asesoramiento y la comunicación con sus clientes.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <div className="promo-area">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="promo-inner">
                                    <div className="row align-items-center">
                                        <div className="col-lg-6 col-md-12">
                                            <div className="content">
                                                <h2>
                                                    Compromiso
                                                </h2>
                                                <p>
                                                    Mantenemos un compromiso con nuestros clientes desde el primer contacto hasta el trabajo de posventa. Generamos un ambiente de colaboración que los lleven a soluciones concretas.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12">
                                            <div className="image">
                                                <img src={process.env.PUBLIC_URL + "/assets/img/nosotros/compromiso.jpg"} alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="promo-inner">
                                    <div className="row align-items-center">
                                        <div className="col-lg-6 col-md-12 d-none d-md-block">
                                            <div className="image">
                                                <img src={process.env.PUBLIC_URL + "/assets/img/nosotros/calidad.jpg"} alt="" />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12">
                                            <div className="content">
                                                <h2>
                                                    Calidad
                                                </h2>
                                                <p>
                                                    Nuestros productos son construidos según los lineamientos de ISO 9000 y cada bomba y equipo es probado y calibrado de forma individual para garantizar que los mismos puedan cummplir con los requerimientos del cliente.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12 d-md-none">
                                            <div className="image">
                                                <img src={process.env.PUBLIC_URL + "/assets/img/nosotros/calidad.jpg"} alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="promo-inner">
                                    <div className="row align-items-center">
                                        <div className="col-lg-6 col-md-12">
                                            <div className="content">
                                                <h2>
                                                    Atención
                                                </h2>
                                                <p>
                                                    Nuestros departamentos técnico de ventas y de atención al cliente se encuentran siempre dispuestos a solucionar cualquier incoveniente o consulta que pueda presentarse en un proyecto o instalación para llegar al mejor resultado posible.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12">
                                            <div className="image">
                                                <img src={process.env.PUBLIC_URL + "/assets/img/nosotros/atencioncliente.jpg"} alt="D" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="container">
                    <blockquote className="blockquote">
                        <div className="image">
                            <img src="assets/img/about/about-quote.jpg" alt="Demo Image" />
                        </div>
                        <p>On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire, that they cannot foresee the pain and trouble that are bound to ensue; and equal blame belongs to those who fail in their duty through weakness of will stop.</p>
                        <span>- Royela Dicasa, CEO</span>
                    </blockquote>
                </div> */}
            </div>
        </DocumentMeta>

    );
}

export default Nosotros;